import React, {useEffect } from 'react';
import Hero from '../../component/Home/Hero';
// import Alliances from '../../component/Home/Alliances';
// import ServicesMatrix from '../../component/Home/ServicesMatrix';
import AboutSustainability from '../../component/Home/AboutSustainability';
import DetailedServices from '../../component/Home/DetailedServices';
import Testimonials from '../../component/Home/Testimonials';

export default function App() {
  
  useEffect(() => {
    document.title = "CMJ Global | Ship Surveyors & Consultants";
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F3] font-sans text-[#2C3539] selection:bg-[#87412A] selection:text-white">
      
      
      <main>
        {/* Main Brand Presentation and Stat Counter */}
        <Hero />
        
        {/* Inspection Framework Indicators */}
        {/* <Alliances /> */}
        
        {/* Dynamic 6-Pillared Capability Matrix */}
        {/* <ServicesMatrix /> */}
        {/* Main Strategic Profile Text & Sustainability Block */}
        <AboutSustainability />
        
        {/* Complete 6-Part Technical Service Blocks */}
        <DetailedServices />
        
        {/* Client Feedback Matrix & Organization Lists */}
        <Testimonials />
        
        {/* Future expansion blocks like an About Section or Contact Form can sit here */}
      </main>

    </div>
  );
}